module.exports = "/fast-coin/img/coin/coin_start_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/coin_start_2.png
// module id = 2381
// module chunks = 5